export function getClientTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function getClientLocale() {
  return navigator.language
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/tracking-client-utils/index.js